





import { Component, Vue, Prop } from 'vue-property-decorator'

@Component<PagesLayoutView>({})
export default class PagesLayoutView extends Vue {}
